<template>
  <div id="app">
    <Navbar />
    <router-view class="app-content" />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
};
</script>

<style lang="scss">
// Import Bulma's core
@import '~bulma/sass/utilities/_all';
@import './styles/variables.scss';

$color-preset-default: $info;

// https://lospec.com/palette-list/ega-com-extended
$color-preset-1: #292929;
$color-preset-2: #d04043;
$color-preset-3: #538a6a;
$color-preset-4: #52575c;
$color-preset-5: #cb8f21;
$color-preset-6: #63b465;
$color-preset-7: #94999e;
$color-preset-8: #e6c439;
$color-preset-9: #2c4267;
$color-preset-10: #6c4b37;
$color-preset-11: #38668b;
$color-preset-12: #7b2d2f;
$color-preset-13: #8c6946;
$color-preset-14: #775780;
$color-preset-15: #f4a66c;
$color-preset-16: #9d446a;
$color-preset-17: #eb7272;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  'white': (
    $white,
    $black,
  ),
  'black': (
    $black,
    $white,
  ),
  'light': (
    $light,
    $light-invert,
  ),
  'dark': (
    $dark,
    $dark-invert,
  ),
  'primary': (
    $primary,
    $primary-invert,
  ),
  'info': (
    $info,
    $info-invert,
  ),
  'success': (
    $success,
    $success-invert,
  ),
  'warning': (
    $warning,
    $warning-invert,
  ),
  'danger': (
    $danger,
    $danger-invert,
  ),
  'twitter': (
    $twitter,
    $twitter-invert,
  ),
  'color-preset-default': (
    $color-preset-default,
    $white,
  ),
  'color-preset-1': (
    $color-preset-1,
    $white,
  ),
  'color-preset-2': (
    $color-preset-2,
    $white,
  ),
  'color-preset-3': (
    $color-preset-3,
    $white,
  ),
  'color-preset-4': (
    $color-preset-4,
    $white,
  ),
  'color-preset-5': (
    $color-preset-5,
    $white,
  ),
  'color-preset-6': (
    $color-preset-6,
    $white,
  ),
  'color-preset-7': (
    $color-preset-7,
    $white,
  ),
  'color-preset-8': (
    $color-preset-8,
    $white,
  ),
  'color-preset-9': (
    $color-preset-9,
    $white,
  ),
  'color-preset-10': (
    $color-preset-10,
    $white,
  ),
  'color-preset-11': (
    $color-preset-11,
    $white,
  ),
  'color-preset-12': (
    $color-preset-12,
    $white,
  ),
  'color-preset-13': (
    $color-preset-13,
    $white,
  ),
  'color-preset-14': (
    $color-preset-14,
    $white,
  ),
  'color-preset-15': (
    $color-preset-15,
    $white,
  ),
  'color-preset-16': (
    $color-preset-16,
    $white,
  ),
  'color-preset-17': (
    $color-preset-17,
    $white,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Footer
$footer-padding: 2rem 1.5rem 2rem;

// Modal
$modal-card-head-background-color: white;
$modal-card-body-background-color: white;

// Navbar
$navbar-breakpoint: $tablet;

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.app-content {
  flex: 1;
}

.dropdown-content {
  padding-top: 0px;
  padding-bottom: 0px;
}
.custom-modal {
  .modal-card-body {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .modal-card-foot {
    background-color: white;
    justify-content: flex-end;
  }
}

.field.is-grouped .action-buttons:not(:last-child) {
  margin-right: 0.75rem;
}

.action-buttons {
  justify-content: left;
}
</style>
